"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLICY_BILLING_TYPE_LABEL_MAP = void 0;
var coverage_api_1 = require("@newfront-insurance/coverage-api");
exports.POLICY_BILLING_TYPE_LABEL_MAP = (_a = {},
    _a[coverage_api_1.PolicyBillingType.DIRECT] = 'Direct - Pay in full',
    _a[coverage_api_1.PolicyBillingType.DIRECT_FINANCED] = 'Direct - Financed',
    _a[coverage_api_1.PolicyBillingType.DIRECT_INSTALLMENTS] = 'Direct - Installments',
    _a[coverage_api_1.PolicyBillingType.AGENT] = 'Agency - Pay in full',
    _a[coverage_api_1.PolicyBillingType.FINANCED] = 'Agency - Financed',
    _a[coverage_api_1.PolicyBillingType.INSTALLMENTS] = 'Agency - Installments',
    _a);
